import { Icon } from "../Icon";
import styled from "styled-components";

export const BlankImage = () => {
  return (
    <Container>
      <Icon iconName="image" iconSize="extraLarge" variant="DISABLED" plain />
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  height: 100%;
  background-color: var(--color-primary-100);
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
`;
